import styled from 'styled-components';

export const Badge = styled.span`
  padding: 0 5px;
  font-size: 12px;
  min-width: 20px;
  font-weight: 400;
  margin-left: 6px;
  line-height: 20px;
  border-radius: 20px;
  display: inline-block;
  vertical-align: middle;
  color: var(--v3-color-on-primary);
  background-color: var(--v3-primary-6);
`;

export const Tab = styled.div<{
  key: number;
  active: boolean;
  fullwidth: boolean;
  onClick: Function;
  tabsCount: number;
  fromMenu?: boolean;
}>`
  cursor: pointer;
  text-align: center;
  color: var(--v3-text-color);
  background-color: var(--v3-black-0);
  ${props => props.fromMenu && 'border-bottom: 1px solid var(--v3-black-4)'};
  ${props => props.fullwidth && 'flex: 1;'}
  ${props =>
    props.active
      ? ` 
      font-weight: 600;
      ${
        props.tabsCount > 1 &&
        `border-bottom: ${
          props.fromMenu ? '1px' : '2px'
        } solid var(--v3-primary-6)`
      };
  `
      : `color: var(--v3-text-color-secondary);
       & > span {
        background-color: var(--v3-primary-4);
       }`};
`;

export const Wrapper = styled.div<{ bordered: boolean }>`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  ${props =>
    props.bordered &&
    ` border-top: 1px solid var(--v3-black-4); 
    `}
`;

const SUBTRACT_PADDING_TOP = 3;

export const Container = styled.div<{
  fixedTop?: number;
  size: 'default' | 'middle' | 'large';
  fromMenu?: boolean;
}>`
  flex: 1;
  ${props =>
    props.fixedTop !== undefined &&
    ` padding-top: ${props.fixedTop - SUBTRACT_PADDING_TOP}px;
      ${Wrapper} {
        position: fixed;
        top: ${props.fixedTop}px;
        left: 0;
        right: 0;
        z-index: 1;
      }
  `}
  ${props => {
    switch (props.size) {
      case 'default':
        return `
          ${Tab} {
            font-size: 12px;
            ${!props.fromMenu && 'line-height: 38px'}
          }
        `;
      case 'middle':
        return `
          ${Tab} {
            font-size: 14px;
            line-height: 42px;
          }
        `;
      case 'large':
        return `
          ${Tab} {
            padding: 0 20px;
            font-size: 16px;
            min-width: 190px;
            line-height: 54px;
          }
        `;
    }
  }}
`;
